import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useListDigitalSubscriptionProducts } from "services/member";
import { BillingProduct } from "protogen/billing_pb";
import Loading from "components/common/Loading";
import DigitalSubscriptionCheckout from "./DigitalSubscriptionCheckout";

export default () => {
  const location = useLocation();
  const selectedProductId: string | undefined =
    (location.state as any)?.selectedProductId ?? undefined;
  const [products, setProducts] = useState<BillingProduct[] | null>(null);
  const { request, loading } = useListDigitalSubscriptionProducts((r) =>
    setProducts(r.products),
  );

  useEffect(() => {
    request({});
  }, []);

  if (loading || products === null) {
    return <Loading />;
  }

  return (
    <DigitalSubscriptionCheckout
      products={products}
      initialProductId={selectedProductId}
    />
  );
};
